import { ReactNode } from 'react';
import { Label } from '@/common/components/Label/Label';
import { Stack } from '@/common/components/Stack/Stack';
import { ROUTES } from '@/common/constants/routes';
import { DateUtils } from '@/common/utils/date';
import {
  Flex,
  Table,
  TableCell,
  TableRow,
  Text,
} from '@coverflex-tech/hypernova';
import { MoneyUtils, TMoney } from '@coverflex-tech/hypernova-utils';
import cx from 'classnames';
import { usePathname } from 'expo-router';
import { css } from './TransactionsTable.css';

export interface TTransactionRow {
  icon: ReactNode;
  date: string;
  description: ReactNode;
  statusBadge?: ReactNode;
  amount: TMoney;
  savingsAmount?: TMoney;
  isDebit: boolean;
  disabled?: boolean;
  action?: () => void;
  secondaryAmount?: TMoney;
}

export function TransactionsTable({ rows }: { rows: TTransactionRow[] }) {
  const pathname = usePathname();

  return (
    <Table
      className={css.table}
      cellPy="lg"
      rows={rows.map((row, idx) => {
        return (
          <TableRow key={idx} onClick={row.action}>
            <TableCell
              className={cx(css.iconCell, {
                [css.disabledCell!]: row.disabled,
              })}
            >
              {row.icon}
            </TableCell>
            <TableCell
              className={cx(css.descriptionCell, {
                [css.disabledCell!]: row.disabled,
              })}
            >
              <Flex flexDirection="column">
                <span>{row.description}</span>
                <Text size="sm" color="neutral20">
                  {DateUtils.formatDate(row.date)}
                </Text>
              </Flex>
            </TableCell>
            <TableCell className={css.statusCell}>{row.statusBadge}</TableCell>
            <TableCell
              align="right"
              className={cx(css.amountCell, {
                [css.amountCredit!]: !row.isDebit,
                [css.amountDisabled!]: row.disabled,
              })}
            >
              <Stack align="end">
                <Label bold size="sm">
                  {row.isDebit ? '-' : '+'}
                  {MoneyUtils.moneyToString(row.amount)}
                </Label>
                {pathname === ROUTES.MEAL_VOUCHER && row.secondaryAmount && (
                  <Label size="sm" color="neutral20">
                    {MoneyUtils.moneyToString(row.secondaryAmount)}
                  </Label>
                )}
              </Stack>
            </TableCell>
            {!row.action && <TableCell className={css.chevronCell} />}
          </TableRow>
        );
      })}
    />
  );
}
